import script from "./FrequencyChangeApply.vue?vue&type=script&setup=true&lang=js"
export * from "./FrequencyChangeApply.vue?vue&type=script&setup=true&lang=js"

import "./FrequencyChangeApply.vue?vue&type=style&index=0&id=7bc0cbdf&scoped=true&lang=css"

import exportComponent from "D:\\SVNwork\\01_工程区\\01_代码\\RPAPortal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7bc0cbdf"]])

export default __exports__